<script lang="ts">
	// see https://github.com/sveltejs/kit/pull/6197#issue-1348175366
	// export const csr = false;
	// export const prerender = true;
	// export const prerender = 'auto';
	// export const csr = true;

	import '../global.postcss';
	// import { theme } from '$lib/store';
	import { onMount, type ComponentType } from 'svelte';
	import Loader from '$lib/components/common/Loader.svelte';
	import ListSignup from '$lib/components/hero/listSignup.svelte';
	import Sidebar from '$lib/components/common/Sidebar.svelte';
	import Footer from '$lib/components/footer/footer.svelte';
	import { browser } from '$app/environment';
	import { loadPlacenames } from '$lib/locations/placenames.store';
	// import { beforeNavigate } from '$app/navigation';
	import { navigating } from '$app/stores';
	import PageNavIndicator from '$lib/components/common/PageNavIndicator.svelte';
	import AlertList from '$lib/components/alert/AlertList.svelte';
	import {
		getProfile,
		profileStore,
		user
		// history
	} from '$lib/user';
	import { setSupabaseAuthJWT } from '$lib/supabase';
	import { width } from '$lib/store';

	/** @type {import('./$types').PageData} */
	export let data;
	// let userHasSidebar = false;
	let ParaModal: ComponentType;

	if (data.user) {
		user.set(data.user);
	}

	if (data.profile) {
		profileStore.set(data.profile);
	}

	if (data.supabaseJWT) {
		setSupabaseAuthJWT(data.supabaseJWT);
	}

	// when component loads
	onMount(async () => {
		ParaModal = (await import('$lib/components/para/ParaModal.svelte')).default;

		// fetch the user's profile if logged in
		if (browser && $user?.member) {
			await getProfile();
			// userHasSidebar = true;
		}

		// Default to dark theme
		document.querySelector('html').classList.add('dark');
		await loadPlacenames();
		// Original dark/light theme switch:
		// if ($theme === 'dark') {
		// 	document.querySelector('html').classList.add('dark');
		// }
	});

	// Route history - for testing and troubleshooting, turn this on
	// beforeNavigate(({ to }) => {
	// 	$history = [to.pathname, ...$history];
	// 	// console.log('__layout.svelte::route', $history);
	// });
</script>

<svelte:head>
	<link rel="icon" type="image/svg" data-sveltekit-preload-data="hover" href="/favicon.jpg" />
	<style>
		body {
			background-color: #1b0d2a; /* Example dark purple color */
		}
	</style>
</svelte:head>

{#if $navigating}
	<PageNavIndicator />
{/if}

<svelte:component this={ParaModal} />
<Loader this={() => import('$lib/components/navbar/Navbar.svelte')}>
	<AlertList />
	<div class="grid grid-flow-col bg-cosmicPurple800">
		{#if $user}
			<div
				class="drawerContainer top-0 left-0 fixed z-10 h-full bg-cosmicPurple800 border-r border-cosmicPurplebg overflow-y-auto"
			>
				<Sidebar />
			</div>
		{/if}

		<!-- Main content area -->
		<main
			class="lg:flex-1 {$user
				? 'lg:ml-48 2xl:ml-64 3xl:-pl-80'
				: ''} overflow-x-hidden min-h-screen flex flex-col"
		>
			<slot />
		</main>
	</div>
	<footer class={$user ? 'lg:ml-48 4xl:-pl-96' : ''}>
		<ListSignup />

		<Footer />
	</footer>
	<!-- FAB: Only show for mobile, logged-in members -->
	{#if $user?.member && $width < 640}
		<a
			rel="noreferrer"
			href="/create/creative/"
			class="fixed bottom-6 right-6 z-50 sm:hidden"
			aria-label="Create Post"
		>
			<button
				class="w-16 h-16 rounded-full flex items-center justify-center border-2 p-1 border-gradientBlueMid text-cosmicPurple800 shadow-lg shadow-black transition-transform duration-150 active:scale-95"
			>
				<svg
					class="w-10 h-10"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 31.41 24.46"
					fill="none"
				>
					<path
						d="M31.41 0C27.2 3.5 23.36 3.43 18.7 6.03s-4.87 6.54-4.87 6.54c-.15-1.11.13-3.7.13-3.7-1.46 1.91-1.56 3.71-1.37 6.77s-.24 5.81-.33 6.31.3.78.3.78c.12-.66.54-3.2.74-3.68 1.67-3.93 6.3-4.86 10.33-6.66 4.51-2.02 5.36-3.9 5.36-3.9a9.37 9.37 0 0 1-2.37.92C31.74 5.99 31.41 0 31.41 0ZM23.1 7.18c-4.04 1.9-7.44 3.71-9.53 10.18l-.65 1.98s-.18-.2.11-1.73c1.26-6.6 5.72-9.02 9.87-10.86C29.66 3.74 31.12.72 31.12.72s-.4 2.52-5.61 5.32c-.8.43-1.63.78-2.42 1.15Z"
						style="stroke-width:0;fill:#12c17d"
					/>
					<text
						x="3"
						y="20"
						style="fill:#12c17d;font-family:SofiaProSoftBold,'Sofia Pro Soft';font-size:17px"
						>+</text
					>
				</svg>
			</button>
		</a>
	{/if}
</Loader>

<style>
	/* Define scrollbar width and color */
	::-webkit-scrollbar {
		width: 12px;
	}

	/* Handle on hover and set background color */
	::-webkit-scrollbar-thumb {
		background-color: #392373; /* Adjust color as needed */
		border-radius: 6px;
	}

	/* Track background color */
	::-webkit-scrollbar-track {
		background-color: #261942; /* Adjust color as needed */
		border-radius: 6px;
	}

	/* Define scrollbar width and color for Firefox */
	/* Firefox supports scrollbar styling using the scrollbar-color property */
	/* You need to apply these styles to a specific container */
	/* In this example, we apply it to the body */
	.drawerContainer {
		scrollbar-width: thin;
		scrollbar-color: #261942 #392373; /* Adjust colors as needed */
		background-color: #1b0d2a;
	}
</style>
